import React from 'react'
import VizSensor from  'react-visibility-sensor'
import PropTypes from "prop-types"

import * as S from './styles'


const Viewport = ({children, partialVisibility = true, animateOpacity = true}) => {


  return(
    <VizSensor
      partialVisibility={partialVisibility}
    >
    {({isVisible}) => (
      <S.Animate animateOpacity={animateOpacity} isVisible={isVisible}>{children({isVisible })}</S.Animate>
    )}
      
    </VizSensor>
  )
}


Viewport.propTypes = {
  children: PropTypes.func.isRequired,
  partialVisibility: PropTypes.bool,
  animateOpacity: PropTypes.bool,
}

export default Viewport
